import { Injectable } from "@angular/core";
import { CryptocoinsState } from "@modules/+new/payments/shared-payments/services/cryptocoins-state.service";
import { Observable } from "rxjs";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { map } from "rxjs/operators";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";

@Injectable()
export class MultichainContactFacade {
	constructor(private readonly cryptocoinsState: CryptocoinsState) {}

	public getCoinsForDropDown(): Observable<BpSelectOption[]> {
		return this.cryptocoinsState.sortedCryptoListForContacts$.pipe(
			map((cryptoList) =>
				cryptoList.map((crypto) => {
					let option = new BpSelectOption();
					option.value = crypto.cryptocoin_id.toString();
					option.name = crypto.name[0].toUpperCase() + crypto.name.substring(1).toLowerCase();
					option.iconUrl = crypto.logo;
					return option;
				})
			)
		);
	}

	public getCoinById(coinId: string): Observable<PaymentsCryptocoin> {
		return this.cryptocoinsState.cryptocoins.pipe(
			map((cryptoList) => {
				const crypto = cryptoList.find((cr) => cr.cryptocoin_id.toString() === coinId);
				if (crypto) {
					return crypto;
				}
				return null;
			})
		);
	}

	public getNetworksForSelectedCoin(coinId: string): Observable<BpSelectOption[]> {
		return this.cryptocoinsState.cryptocoins.pipe(
			map((cryptoList) => {
				const crypto = cryptoList.find((cr) => cr.cryptocoin_id.toString() === coinId);
				if (crypto) {
					return crypto.networks.map((network) => {
						let option = new BpSelectOption();
						option.value = network.coin_network_id;
						option.name = network.name[0].toUpperCase() + network.name.substring(1).toLowerCase();
						option.iconUrl = network.logo;
						return option;
					});
				}
				return [];
			})
		);
	}

	public getDefaultNetworkId(coinId: string): Observable<string> {
		return this.cryptocoinsState.cryptocoins.pipe(
			map((cryptoList) => {
				const crypto = cryptoList.find((cr) => cr.cryptocoin_id.toString() === coinId);
				if (crypto) {
					return crypto.networks.find((network) => network.id === crypto.default_network_id).coin_network_id;
				}
				return "";
			})
		);
	}

	public getNetworkByCoinAndNetworkId(coinId: string, coinNetworkId: string): Observable<Network> {
		return this.getCoinById(coinId).pipe(
			map((coin) =>
				coin.networks.find((network) => {
					return network.coin_network_id === coinNetworkId;
				})
			)
		);
	}
}
